import { Injectable } from '@angular/core';
import { MenuConstant } from '../../contants/menu.constant';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { MenuItem } from '../../models/menu/menu-item.class';
import { SeleccionProducto } from '../../models/menu/seleccion-producto.class';
import { RedireccionMenu } from '../../models/menu/redireccion-menu.class';
import { UrlService } from '../../contants/url-service.constant';
import { OpcionVentana } from '../../contants/opcion-ventana.constant';
import { Configuracion } from '../../contants/configuracion.constant';
import { HttpCustom } from '../http/http-custom.service';
import { PerfilConstant } from '../../contants/perfil.constant';
import { HeaderPeticion } from '../../models/http/headerPeticion.class';

@Injectable()
export class MenuService {
  private ListMenu: BehaviorSubject<MenuItem[]> = new BehaviorSubject<
    MenuItem[]
  >([]);

  private ListMenuPush: MenuItem[] = [];

  private listBusquedaMenu: BehaviorSubject<SeleccionProducto[]> =
    new BehaviorSubject<SeleccionProducto[]>([]);

  private listBusquedaPush: SeleccionProducto[] = [];

  constructor(private httpCustom: HttpCustom) {}

  async cargarMenu(perfil, agente) {
    this.ListMenuPush = [];
    this.cargarInicio();

    let cargoProductos;

    await this.cargarSoluciones(perfil, agente).then(resp => {
      cargoProductos = resp;
    }
      );

    if (cargoProductos) {
      this.cargarMisNegocios();
      this.cargarMisClientes();
      // this.cargarMisMapas();
      // this.cargarMapasRiesgos();
      this.cargarFormatos();
      this.cargarMenuSalir();
      this.notificarCargaMenu();
    }
  }

  cargarInicio() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_INICIO,
      MenuConstant.OPCIONES_COTIZADOR_MENU_INICIO,
      MenuConstant.DS_COTIZADOR_MENU_INICIO,
      MenuConstant.DS_COTIZADOR_MENU_INICIO,
      MenuConstant.RUTA_IMG_MENU_INICIO,
      [],
      MenuConstant.CLASS_MENU_INICIO,
      true,
      this.crearedireccionMenu(
        MenuConstant.RUTA_MENU_INICIO,
        '',
        '',
        true,
        MenuConstant.CLASS_MENU_INICIO,
        false
      )
    );
  }

  async cargarSoluciones(perfil, agente): Promise<boolean> {
    let menuSoluciones;
    await this.cargarMenuSoluciones(perfil, agente).then(resp => {
      menuSoluciones = resp;
    });


    this.cargarListaBusquedaMenu('', '', menuSoluciones);
    this.notificarCargarBusquedaMenu();

    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_SOLUCIONES,
      MenuConstant.OPCIONES_COTIZADOR_MENU_SOLUCIONES,
      MenuConstant.DS_COTIZADOR_MENU_SOLUCIONES,
      MenuConstant.DS_COTIZADOR_MENU_SOLUCIONES,
      MenuConstant.RUTA_IMG_MENU_SOLUCIONES,
      menuSoluciones,
      MenuConstant.CLASS_MENU_SOLUCIONES,
      true
    );

    return true;
  }

  cargarMisNegocios() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_MIS_NEGOCIOS,
      MenuConstant.OPCIONES_COTIZADOR_MENU_MIS_NEGOCIOS,
      MenuConstant.DS_COTIZADOR_MENU_MIS_NEGOCIOS,
      MenuConstant.DS_COTIZADOR_MENU_MIS_NEGOCIOS,
      MenuConstant.RUTA_IMG_MENU_NEGOCIOS,
      [],
      MenuConstant.CLASS_MENU_MIS_NEGOCIOS,
      true,
      this.crearedireccionMenu(
        Configuracion.REDIRECCION_COTIZADOR_NUEVO_MIS_NEGOCIOS,
        '',
        '',
        true,
        MenuConstant.CLASS_MENU_MIS_NEGOCIOS,
        false,
        OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA
      )
    );
  }

  cargarMisClientes() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_MIS_CLIENTES,
      MenuConstant.OPCIONES_COTIZADOR_MENU_MIS_CLIENTES,
      MenuConstant.DS_COTIZADOR_MENU_MIS_CLIENTES,
      MenuConstant.DS_COTIZADOR_MENU_MIS_CLIENTES,
      MenuConstant.RUTA_IMG_MENU_MIS_CLIENTES,
      [],
      MenuConstant.CLASS_MENU_MIS_CLIENTES,
      true,
      this.crearedireccionMenu(
        Configuracion.REDIRECCION_COTIZADOR_NUEVO_MIS_CLIENTES,
        '',
        '',
        true,
        MenuConstant.CLASS_MENU_MIS_CLIENTES,
        false,
        OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA
      )
    );
  }

  /* cargarMisMapas() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_MIS_MAPAS,
      MenuConstant.OPCIONES_COTIZADOR_MENU_MIS_MAPAS,
      MenuConstant.DS_COTIZADOR_MENU_MIS_MAPAS,
      MenuConstant.DS_COTIZADOR_MENU_MIS_MAPAS,
      MenuConstant.RUTA_IMG_MENU_MIS_MAPAS,
      [],
      MenuConstant.CLASS_MENU_MIS_MAPAS,
      true,
      this.crearedireccionMenu(
        Configuracion.REDIRECCION_COTIZADOR_MIS_MAPA,
        '',
        '',
        false,
        MenuConstant.CLASS_MENU_MIS_MAPAS,
        false,
        OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA
      )
    );
  }

   cargarMapasRiesgos() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_MAPA_RIESGOS,
      MenuConstant.OPCIONES_COTIZADOR_MENU_MAPA_RIESGOS,
      MenuConstant.DS_COTIZADOR_MENU_MAPA_RIESGOS,
      MenuConstant.DS_COTIZADOR_MENU_MAPA_RIESGOS,
      MenuConstant.RUTA_IMG_MENU_MAPA_RIESGOS,
      [],
      MenuConstant.CLASS_MENU_MAPA_RIESGOS,
      true,
      this.crearedireccionMenu(
        Configuracion.REDIRECCION_COTIZADOR_MAPA_RIESGOS,
        '',
        '',
        false,
        MenuConstant.CLASS_MENU_MAPA_RIESGOS,
        false,
        OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA
      )
    );
  } */

  cargarFormatos() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_FORMATOS,
      MenuConstant.OPCIONES_COTIZADOR_MENU_FORMATOS,
      MenuConstant.DS_COTIZADOR_MENU_FORMATOS,
      MenuConstant.DS_COTIZADOR_MENU_FORMATOS,
      MenuConstant.RUTA_IMG_MENU_FORMATOS,
      [],
      MenuConstant.CLASS_MENU_FORMATOS,
      true,
      this.crearedireccionMenu(
        Configuracion.REDIRECCION_COTIZADOR_FORMATOSV2,
        '',
        '',
        false,
        MenuConstant.CLASS_MENU_FORMATOS,
        false,
        OpcionVentana.REDIRECCION_DIRECTA_COTIZADOR_PA
      )
    );
  }

  cargarMenuContactos() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_CONTACTO,
      MenuConstant.OPCIONES_COTIZADOR_MENU_CONTACTO,
      MenuConstant.DS_COTIZADOR_MENU_CONTACTO,
      MenuConstant.DS_COTIZADOR_MENU_CONTACTO,
      MenuConstant.RUTA_IMG_MENU_CONTACTO,
      [],
      MenuConstant.CLASS_MENU_CONTACTO,
      true,
      this.crearedireccionMenu(
        Configuracion.REDIRECCION_CONTACTO,
        '',
        '',
        false,
        MenuConstant.CLASS_MENU_CONTACTO,
        false,
        OpcionVentana.REDIRECCION_DIRECTA_NUEVA_PESTANA
      )
    );
  }

  cargarMenuSalir() {
    this.crearOpcionMenu(
      MenuConstant.OPCIONES_COTIZADOR_MENU_SALIR,
      MenuConstant.OPCIONES_COTIZADOR_MENU_SALIR,
      MenuConstant.DS_COTIZADOR_MENU_SALIR,
      MenuConstant.DS_COTIZADOR_MENU_SALIR,
      MenuConstant.RUTA_IMG_MENU_SALIR,
      [],
      MenuConstant.CLASS_MENU_SALIR,
      true,
      this.crearedireccionMenu(
        UrlService.LOGOUT,
        '',
        '',
        false,
        MenuConstant.CLASS_MENU_SALIR,
        true
      )
    );
  }

  private crearOpcionMenu(
    cdresource: number,
    order: number,
    name: string,
    contextPath: string,
    image: string,
    children: any,
    styleClass: string,
    isStatic: boolean,
    redireccionMenu?: RedireccionMenu
  ) {
    this.ListMenuPush.push(
      new MenuItem(
        cdresource,
        order,
        name,
        contextPath,
        image,
        children,
        styleClass,
        isStatic,
        redireccionMenu
      )
    );
  }

  private async cargarMenuSoluciones(perfil, agente) {
    let listSoluciones: MenuItem[] = [];
    if (perfil !== null && agente !== null) {
      if (
        PerfilConstant.PERFIL_DELEGADO === perfil ||
        PerfilConstant.PERFIL_COMERCIAL === perfil ||
        PerfilConstant.PERFIL_COMERCIAL_DELEGADO === perfil ||
        PerfilConstant.PERFIL_SALUD_PROVEDOR_DELEGADO === perfil
      ) {
        await this.cargarInformacionMenuAsesorDelegado(agente).then(resp => {
          listSoluciones = resp;
        });
      } else {
        await this.cargarInformacionMenu(
          this.cargarFiltroMenuAseosrAuxiliar(perfil, agente)
        ).then(resp => {
          listSoluciones = resp;
        });
      }
      return listSoluciones;
    }
  }

  cargarFiltroMenuAseosrAuxiliar(perfil, agente) {
    let filtros = {};
    if (PerfilConstant.PERFIL_ASESOR === perfil) {
      filtros = {
        regional: agente.informacionComplementaria.asesor.regional,
        oficina: agente.informacionComplementaria.asesor.codigoDelegacion,
        asesor: agente.informacionComplementaria.asesor.codigo,
      };
    }
    return filtros;
  }

  cargarInformacionMenuAsesorDelegado(agente): Promise<MenuItem[]> {
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.URL_HOME_DELEGADO, {
        cargoAgente: agente.informacionComplementaria.asesor.cargo,
        regional: agente.informacionComplementaria.asesor.regional, oficina: agente.informacionComplementaria.asesor.codigoDelegacion,
        asesor: agente.informacionComplementaria.asesor.codigo
      }, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Información del Menu')]).subscribe(
        result => resolve(result),
        error => reject(null)
      );
    });
  }

  cargarInformacionMenu(filtros): Promise<MenuItem[]> {
    return new Promise((resolve, reject) => {
      this.httpCustom.getServiceWithHeaders(UrlService.URL_HOME_MENU, filtros, [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Cargando Información del Menu')]).subscribe(
        result => resolve(result),
        error => reject(null)
      );
    });
  }

  private cargarListaBusquedaMenu(
    base: string,
    baseNombre: string,
    menuSoluciones: MenuItem[]
  ) {
    if (menuSoluciones !== null && menuSoluciones.length > 0) {
      menuSoluciones.forEach((itemMenu) => {
        const seleccionProducto: SeleccionProducto = new SeleccionProducto();
        seleccionProducto.contextPath = this.construirContextPath(
          base,
          itemMenu.contextPath.toString()
        );
        seleccionProducto.opcionEjecutada =
          seleccionProducto.opcionEjecutada.concat(
            itemMenu.contextPath.toString()
          );
        seleccionProducto.nombreBusqueda = this.construirNombreAccion(
          baseNombre,
          itemMenu.name.toString()
        );

        if (
          itemMenu.children !== undefined &&
          itemMenu.children !== null &&
          itemMenu.children.length > 0
        ) {
          this.cargarListaBusquedaMenu(
            seleccionProducto.contextPath.toString(),
            seleccionProducto.nombreBusqueda.toString(),
            itemMenu.children
          );
        } else {
          if (itemMenu.target !== null && itemMenu.target !== '') {
            itemMenu.redireccionMenu = this.crearedireccionMenu(itemMenu.target, itemMenu.detalleOpcion.documento,
            itemMenu.contextPath.toString(),
              false, itemMenu.detalleOpcion.nombreRecurso, false, itemMenu.windowOptions);
          } else {
            itemMenu.redireccionMenu = this.crearedireccionMenu(
              Configuracion.REDIRECCION_COTIZADOR_CONECTADO,
              itemMenu.detalleOpcion.documento,
              itemMenu.contextPath.toString(),
              false,
              itemMenu.detalleOpcion.nombreRecurso,
              false,
              OpcionVentana.REDIRECCION_DIRECTA
            );
          }
          seleccionProducto.menuItem = itemMenu;

          this.listBusquedaPush.push(seleccionProducto);
        }
      });
    }
  }

  private crearedireccionMenu(
    url: String,
    tipoDocumento: String,
    contextpath: string,
    isLocal: boolean,
    codigoRecurso: String,
    isLogout: boolean = false,
    opcionVentana: String = OpcionVentana.REDIRECCION_DIRECTA
  ): RedireccionMenu {
    return new RedireccionMenu(
      url,
      isLocal,
      isLogout,
      opcionVentana,
      contextpath,
      codigoRecurso,
      tipoDocumento
    );
  }

  private construirContextPath(base: string, contextPath: string): string {
    return base !== null && base !== undefined && base !== ''
      ? base + '/' + contextPath
      : contextPath;
  }

  private construirNombreAccion(
    baseNombre: string,
    nombreItem: string
  ): string {
    return baseNombre !== null && baseNombre !== undefined && baseNombre !== ''
      ? baseNombre + '/' + nombreItem
      : nombreItem;
  }

  private notificarCargaMenu() {
    this.ListMenu.next(this.ListMenuPush);
  }

  private notificarCargarBusquedaMenu() {
    this.listBusquedaMenu.next(this.listBusquedaPush);
  }

  getListMenu() {
    return this.ListMenu;
  }

  setListMenuPush(listMenu) {
    this.ListMenuPush = listMenu;
  }

  getListMenuPush() {
    return this.ListMenuPush;
  }

  getListBusquedaMenu() {
    return this.listBusquedaMenu;
  }

  redireccionarLogin(): Promise<string> {
    return new Promise((resolve, reject) => {
     this.httpCustom
        .getServiceWithHeadersText(
          UrlService.URL_LOGIN,
          {},
          [new HeaderPeticion(Configuracion.HEADER_DESCRIPCION_PETICION, 'Obteniendo URL Login') , new HeaderPeticion('Content-Type', 'text/plain; charset=utf-8')]
        )
        .subscribe(
          (result) => {
            resolve(result);
          },
          (error) => {
            console.log("Error al obtener la URL de Login", error);
            reject(null)}
        );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/menu/menu.service.ts